import React, { FC } from 'react'
import { useSuspenseQuery } from '@moonpig/web-core-graphql'
import { Carousel } from '@moonpig/web-shared-components'
import { MoreLikeThisQuery } from '../query/__generated__/moreLikeThis'
import { MoreLikeThisGQL } from '../query/moreLikeThis'
import { NUMBER_OF_PRODUCTS_TO_FETCH } from '../constants'
import { SimpleCardTile } from './SimpleCardTile'
import { AddedToBasketEvent } from '../../../types'

export const MoreLikeThisProducts: FC<{
  onAddToBasket: (addedEvent: AddedToBasketEvent) => void
}> = ({ onAddToBasket }) => {
  const { data } = useSuspenseQuery<MoreLikeThisQuery>(MoreLikeThisGQL, {
    variables: {
      searchTerm: 'cat',
      department: 'ALL_CARDS',
      limit: NUMBER_OF_PRODUCTS_TO_FETCH,
      offset: 0,
      filters: {},
      experimentValues: '',
      platform: 'WEB',
      nbaAlgorithm: 'default',
      sortOrder: 'POPULARITY',
      sponsoredProducts: [],
      isInitialQuery: true,
    },
  })

  const products = data?.productSearch?.products ?? []

  return products.length > 0 ? (
    <Carousel skipLinkHref="#product-after-panel">
      {products.map((product, index) => (
        <SimpleCardTile
          key={product.id}
          product={product}
          index={index}
          onAddToBasket={onAddToBasket}
        />
      ))}
    </Carousel>
  ) : null
}
